import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import { SIDEBAR_NAV } from '../../constants';
import type { Screen } from '../../types';

export default function Sidebar() {
  const { screen, go, currentUser, logout } = useApp();
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div
      id="sidebar"
      style={{
        width: collapsed ? '54px' : '220px',
        background: '#0F1B2D',
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        transition: 'width .25s',
        height: '100vh',
      }}
    >
      {/* Brand */}
      <div style={{ padding: collapsed ? '16px 0 12px' : '16px 16px 12px', display: 'flex', alignItems: 'center', gap: '10px', borderBottom: '1px solid rgba(255,255,255,.07)', flexShrink: 0, justifyContent: collapsed ? 'center' : undefined }}>
        <div style={{ width: '32px', height: '32px', borderRadius: '9px', background: '#C8973A', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '15px', fontWeight: '700', color: '#0F1B2D', flexShrink: 0 }}>e</div>
        {!collapsed && (
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: '13px', fontWeight: '700', color: 'white', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>SalesBook</div>
            <div style={{ fontSize: '10px', color: 'rgba(255,255,255,.45)', marginTop: '1px' }}>{currentUser?.title}</div>
          </div>
        )}
        {!collapsed && (
          <button onClick={() => setCollapsed(true)} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,.35)', cursor: 'pointer', fontSize: '14px', flexShrink: 0, padding: '2px' }}>
            <i className="ti ti-layout-sidebar-left-collapse" />
          </button>
        )}
        {collapsed && (
          <button onClick={() => setCollapsed(false)} style={{ position: 'absolute', left: '54px', top: '14px', display: 'none' }} />
        )}
      </div>

      {/* Expand button when collapsed */}
      {collapsed && (
        <button onClick={() => setCollapsed(false)} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,.35)', cursor: 'pointer', fontSize: '14px', padding: '10px 0', display: 'flex', justifyContent: 'center', flexShrink: 0 }}>
          <i className="ti ti-layout-sidebar-left-expand" />
        </button>
      )}

      {/* Nav */}
      <nav style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', padding: '10px 0' }}>
        {!collapsed && <div style={{ fontSize: '9px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '.1em', color: 'rgba(255,255,255,.55)', padding: '12px 16px 4px', whiteSpace: 'nowrap' }}>Main</div>}

        {SIDEBAR_NAV.map(item => {
          const isActive = screen === item.screen;
          return (
            <button
              key={item.id}
              onClick={() => go(item.screen as Screen)}
              data-label={item.label}
              title={collapsed ? item.label : undefined}
              style={{
                display: 'flex', alignItems: 'center', gap: collapsed ? 0 : '10px',
                padding: collapsed ? '10px 0' : '8px 16px',
                cursor: 'pointer', transition: 'all .15s', position: 'relative',
                color: isActive ? '#E8B55A' : 'rgba(255,255,255,.6)',
                fontSize: '12px', fontWeight: '500', border: 'none',
                background: isActive ? 'rgba(200,151,58,.15)' : 'none',
                fontFamily: 'inherit', width: '100%',
                textAlign: collapsed ? 'center' : 'left',
                justifyContent: collapsed ? 'center' : undefined,
                whiteSpace: 'nowrap',
              }}
            >
              {isActive && (
                <span style={{ position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)', width: '3px', height: '20px', background: '#C8973A', borderRadius: '0 3px 3px 0' }} />
              )}
              <i className={`ti ${item.icon}`} style={{ fontSize: '16px', flexShrink: 0, width: '18px', textAlign: 'center' }} />
              {!collapsed && <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.label}</span>}
              {!collapsed && item.badge && (
                <span style={{ background: item.badgeRed ? '#EF4444' : '#C8973A', color: item.badgeRed ? 'white' : '#0F1B2D', fontSize: '9px', fontWeight: '700', borderRadius: '20px', padding: '1px 7px', flexShrink: 0 }}>
                  {item.badge}
                </span>
              )}
            </button>
          );
        })}
      </nav>

      {/* Footer — user */}
      <div style={{ padding: '10px 12px', borderTop: '1px solid rgba(255,255,255,.07)', flexShrink: 0 }}>
        <div
          onClick={logout}
          style={{ display: 'flex', alignItems: 'center', gap: '9px', cursor: 'pointer', padding: '6px', borderRadius: '8px', justifyContent: collapsed ? 'center' : undefined }}
        >
          <div style={{ width: '30px', height: '30px', borderRadius: '50%', background: '#C8973A', color: '#0F1B2D', fontSize: '11px', fontWeight: '700', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            {currentUser?.ini}
          </div>
          {!collapsed && (
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: '11px', fontWeight: '600', color: 'white', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{currentUser?.name}</div>
              <div style={{ fontSize: '9px', color: 'rgba(255,255,255,.4)' }}>Click to log out</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
